import TradingViewChart from './TradingViewChart';

export default TradingViewChart;
